<template>
  <f7-page login-screen>
    <f7-block class="content__login">
      <div class="text-align-center margin-bottom">
        <img class="img_logo" :src="APP_LOGO" :alt="APP_NAME" />
      </div>
      <div name="txtDataAccess" class="login__label">
        {{ $t('password_recovery') }}
      </div>
      <f7-list form class="no-margin-top" no-hairlines-between>
        <f7-list-input
          class="login-input"
          name="emailInput"
          item-label
          type="password"
          :placeholder="$t('new_password')"
          clear-button
          max="255"
          required
          validate
          :error-message="$t('completeThisField')"
          @input="password = $event.target.value"
        />

        <f7-list-input
          class="login-input"
          item-label
          type="password"
          :placeholder="$t('confirm_new_password')"
          clear-button
          max="255"
          required
          autocomplete="current-password"
          validate
          :error-message="$t('completeThisField')"
          @input="confirmPassword = $event.target.value"
        />
      </f7-list>
      <!-- Buttons -->
      <f7-block class="token-recovery-actions">
        <f7-row>
          <f7-col>
            <f7-button
              name="btnGoBack"
              style="color: white"
              button
              button-large
              fill
              outline
              class="botonSecondary"
              @click="goToLogin"
            >
              {{ $t('cancel') }}
            </f7-button>
          </f7-col>
          <f7-col>
            <f7-button
              name="recoverPasswordButton "
              class="botonPrimary"
              style="color: white"
              button
              button-large
              fill
              @click="resetPassword"
            >
              {{ $t('request_reset_password') }}
            </f7-button>
          </f7-col>
        </f7-row>
      </f7-block>
      <p class="mobile-password-recovery-note">
        {{ $t('mobilePasswordRecoveryMessage') }}
      </p>
    </f7-block>
  </f7-page>
</template>

<script>
import { mapActions } from 'vuex';
import {
  APP_NAME,
  APP_LOGO,
  NOTIFY_TIME_LONG,
} from '../../../js/constants';

export default {
  data() {
    return {
      APP_NAME,
      APP_LOGO,
      password: '',
      confirmPassword: '',
      token: null,
    };
  },
  mounted() {
    // dispatch al event loop
    this.token = this.getQueryParam('token');
  },
  methods: {
    goToLogin() {
      setTimeout(() => {
        window.history.pushState(
          {},
          document.title,
          window.location.pathname
        );
      }, 0);
      this.setShowTokenPage(false);
    },
    getQueryParam(queryParam) {
      const params = new Proxy(
        new URLSearchParams(window.location.search),
        {
          get: (searchParams, prop) => searchParams.get(prop),
        }
      );
      return params[queryParam];
    },
    async resetPassword() {
      if (this.validatePassword()) {
        try {
          this.token = this.getQueryParam('token');
          await this.confirmChangePassword({
            password: this.password,
            token: this.token,
          });

          this.setShowTokenPage(false);

          setTimeout(() => {
            window.history.pushState(
              {},
              document.title,
              window.location.pathname
            );
          }, 0);

          this.$notifyDX(
            {
              message: this.$t('password_updated'),
              width: 450,
            },
            'success',
            3000
          );
        } catch (error) {
          setTimeout(() => {
            window.history.pushState(
              {},
              document.title,
              window.location.pathname
            );
          }, 0);

          this.setShowTokenPage(false);
          this.$notifyDX(
            {
              message: this.$t('invalidToken'),
              width: 450,
            },
            'error',
            NOTIFY_TIME_LONG
          );
        }
      } else {
        this.$notifyDX(
          {
            message: this.$t('new_password_not_match'),
            width: 450,
          },
          'error',
          NOTIFY_TIME_LONG
        );
      }
    },
    validatePassword() {
      if (
        this.password.trim() === this.confirmPassword.trim() &&
        this.password.trim() !== '' &&
        this.confirmPassword.trim() !== ''
      ) {
        return true;
      }

      return false;
    },
    ...mapActions('user', [
      'setShowTokenPage',
      'confirmChangePassword',
    ]),
  },
};
</script>

<style scoped>
.img_logo {
  width: 100%;
  max-width: 200px;
  height: auto;
  margin-bottom: 40px;
}

.login-input :deep(.item-input-wrap input) {
  box-sizing: border-box;
  width: 100%;
  height: 38px;
  min-height: 38px;
  padding: 8px 16px;
  border: 1px solid #00346a;
  border-radius: 10px;
  background-color: #f1f8ff;
  font-size: 16px;
  line-height: 20px;
  color: #00346a !important;
}

.login-input :deep(.item-input-wrap input::placeholder) {
  color: #8a8693;
  opacity: 1;
}

.content__login {
  box-sizing: border-box;
  width: 100%;
  /* tamaño del card: inputs (456px) + padding 64px a cada lado */
  max-width: calc(456px + 64px * 2);
  margin: 64px auto; /* separa del resto de la página */
  padding: 64px; /* como en Figma */
  background: #fff; /* fondo blanco */
  border-radius: 10px; /* radios de 10px */
  box-shadow: 0 4px 4px -1px rgba(87, 84, 95, 0.3),
    0 8px 16px -6px rgba(0, 0, 0, 0.06); /* sombra suave */

  --f7-block-padding-horizontal: 0;
  --f7-block-margin-vertical: 0;
}

.content__login > .list {
  width: 100%;
  margin-left: 0;
  margin-right: 0;
}
.botonPrimary {
  background-color: #00346a !important;
  color: white !important;
  font-weight: 600;
  border-radius: 10px;
  width: 100%;
}

.botonSecondary {
  background-color: white !important;
  border: 1px solid #00346a !important;
  color: #00346a !important;
  font-weight: 600;
  border-radius: 10px;
  width: 100%;
}
div[name='txtDataAccess'] {
  text-align: left;
  font-size: 20px;
  font-weight: 200;
  line-height: 33px;
  color: var(--color-blue-70);
  padding: 0;
}
.input-clear-button {
  position: absolute !important;
  top: 39% !important;
  right: 25px !important;
  transform: translateY(-50%) !important;
  z-index: 2;
  font-size: 14px;
  line-height: 1 !important;
}
/* Quita la línea (hairline) dentro de esta pantalla */
:deep(.login-input .item-inner::after) {
  display: none !important;
}

.mobile-password-recovery-note {
  display: none;
}

@media (max-width: 600px) {
  .content__login {
    margin: 24px auto;
    padding: 24px;
  }

  .img_logo {
    margin-bottom: 24px;
  }

  .login-input :deep(.item-content) {
    padding-left: 0;
  }

  .login-input :deep(.item-inner) {
    padding-right: 0;
  }

  .token-recovery-actions :deep(.row) {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .token-recovery-actions :deep(.col) {
    width: 100%;
    flex: 0 0 auto;
  }

  .token-recovery-actions :deep(.button) {
    margin-top: 0;
  }

  .mobile-password-recovery-note {
    display: block;
    margin: 20px 0 0;
    color: #3e3c44;
    font-size: 13px;
    line-height: 18px;
    text-align: center;
    overflow-wrap: anywhere;
  }
}
</style>
